<template>
    <NavbarMain/>

    <div class="page-title-banner">
        <div class="container">
            <h1>{{ pageData ? pageData.first_section_title : '' }}</h1>
        </div>
    </div>

    <div class="project-documentation-content">
        <div class="container" style="text-align: left;">
            <template v-if="pageData && pageData.sections && pageData.sections.length > 0">
                <div
                    v-for="section in pageData.sections"
                    :key="section.id"
                    class="documentation-section"
                >
                    <h2 class="documentation-section-title">{{ section.title }}</h2>
                    <p v-if="section.description" class="documentation-section-description">
                        {{ section.description }}
                    </p>
                    <ul v-if="section.documents && section.documents.length > 0" class="documentation-document-list">
                        <li v-for="doc in section.documents" :key="doc.id">
                            <a
                                :href="doc.document"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="documentation-document-link"
                            >
                                <span class="documentation-document-icon">&#8617;</span>
                                {{ doc.name }}
                            </a>
                        </li>
                    </ul>
                    <p v-else class="documentation-empty">No documents available for this section.</p>
                </div>
            </template>
            <p v-else-if="pageData" class="documentation-empty">No sections available.</p>
        </div>
    </div>

    <FooterPage />
</template>

<script>
import axios from 'axios';
import NavbarMain from '@/components/NavbarMain.vue';
import FooterPage from '@/components/FooterPage.vue';

export default {
    components: {
        NavbarMain,
        FooterPage,
    },
    data() {
        return {
            pageData: null,
        };
    },
    created() {
        const savedLanguage = localStorage.getItem('currentLanguage');
        if (savedLanguage) {
            this.$store.dispatch('toggleLanguage');
        }
    },
    mounted() {
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

        axios.get(`${API_URL}/api/resources-content`)
            .then(response => {
                const data = response.data;
                if (Array.isArray(data) && data.length > 0) {
                    this.pageData = data[0];
                }
            })
            .catch(error => {
                console.error('Error fetching resources content:', error);
            });
    },
};
</script>

<style>
.page-title-banner {
    background-color: #0058A3;
    margin-top: 10px;
    padding: 3rem 0;
    text-align: center;
}

.page-title-banner h1 {
    color: #fff;
    font-size: 2rem;
    font-weight: 600;
    margin: 0;
}

.project-documentation-content {
    padding: 4rem 0;
    min-height: 300px;
    text-align: left;
}

.documentation-section {
    margin-bottom: 3rem;
    border-bottom: 1px solid #E1E5E8;
    padding-bottom: 2rem;
    text-align: left;
}

.documentation-section:last-child {
    border-bottom: none;
}

.documentation-section-title {
    color: #0058A3;
    font-size: 1.6rem;
    font-weight: 600;
    margin-bottom: 0.75rem;
    text-align: left;
}

.documentation-section-description {
    color: #6E8496;
    margin-bottom: 1.25rem;
    line-height: 1.6;
    text-align: left;
}

.documentation-document-list {
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: left;
}

.documentation-document-list li {
    margin-bottom: 0.6rem;
    text-align: left;
}

.documentation-document-link {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: #0058A3;
    text-decoration: none;
    font-weight: 500;
    padding: 0.5rem 1rem;
    border: 1px solid #0058A3;
    border-radius: 4px;
    transition: background-color 0.2s, color 0.2s;
}

.documentation-document-link:hover {
    background-color: #0058A3;
    color: #fff;
}

.documentation-document-icon {
    font-size: 1rem;
    transform: rotate(180deg);
    display: inline-block;
}

.documentation-empty {
    color: #6E8496;
    font-style: italic;
    text-align: left;
}

@media all and (max-width: 768px) {
    .project-documentation-content {
        padding: 2.5rem 0;
    }

    .documentation-section-title {
        font-size: 1.3rem;
    }
}
</style>
